import type { SyntheticEvent, KeyboardEventHandler } from 'react';

export const a11yButtonProps = (props?: {
  onClick?: (e: SyntheticEvent) => void;
  role?: string;
}) => {
  const { onClick, role } = props ?? {};
  const onKeyDown: KeyboardEventHandler = (e) => {
    if (e.key === 'Enter') {
      onClick?.(e);
    }
  };

  return {
    role: role || 'button',
    onKeyDown,
    onClick,
  };
};
